/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var RotateSquareRightIcon20Solid = forwardRef('RotateSquareRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.632.225a1 1 0 0 0-1.264 1.55L7.644 2H5.5A4.5 4.5 0 0 0 1 6.5V9a1 1 0 1 0 2 0V6.5A2.5 2.5 0 0 1 5.5 4h2.144l-.276.225a1 1 0 0 0 1.264 1.55l1.644-1.342a1.85 1.85 0 0 0 0-2.866L8.632.225Z" }),
        React.createElement("path", { d: "M5 10.25A3.25 3.25 0 0 1 8.25 7h5.5A3.25 3.25 0 0 1 17 10.25v5.5A3.25 3.25 0 0 1 13.75 19h-5.5A3.25 3.25 0 0 1 5 15.75v-5.5Z" })));
});
